export type FilterOption = { value: string; label: string };

export function distinct(values: (string | undefined)[]): string[] {
	return [...new Set(values.filter((value): value is string => !!value))];
}

type FilterableNgo = { countryCode?: string; region?: string };

/** GeoNames prefixes Italy's regions with their legal form ("Regione Autonoma Siciliana"); no other country does. */
const REGION_PREFIX = /^Regione\s+(?:Autonoma\s+)?(?:dell[a']\s*)?/i;

/** Where the cut leaves an adjective. Keyed by what the regex leaves, not the raw name. */
const REGION_ALIASES: Record<string, string> = { Siciliana: 'Sicilia' };

/** A label only: the stored name stays the filter's value. */
export function regionLabel(name: string): string {
	const stripped = name.replace(REGION_PREFIX, '');
	return REGION_ALIASES[stripped] ?? stripped;
}

export function regionOptionsFor(ngos: FilterableNgo[], country: string | null): FilterOption[] {
	const inCountry = country ? ngos.filter((ngo) => ngo.countryCode === country) : ngos;
	return distinct(inCountry.map((ngo) => ngo.region))
		.map((value) => ({ value, label: regionLabel(value) }))
		.sort((a, b) => a.label.localeCompare(b.label));
}
